import { PlugInjectedProvider } from '@plug-core/inpage/PlugInjectedProvider'
import { useConnectionProvider } from '@plug-core/state'

declare global {
  interface Window {
    ic?: {
      plug?: PlugInjectedProvider
    }
  }
}

const isPlugExtensionInstalled = () => {
  return typeof window !== 'undefined' && window.ic?.plug !== undefined
}

export const getPlugExtension = () => {
  if (isPlugExtensionInstalled()) {
    return window.ic!.plug!
  } else {
    return null
  }
}

export const disconnectFromPlugExtension = async () => {
  getPlugExtension()?.disconnect()
}

export const connectPlug = async (): Promise<{ principal: string }> => {
  const plug = getPlugExtension()

  if (!plug) {
    throw new Error('Plug extension not found')
  }

  await plug.requestConnect({
    timeout: 50000,
  })

  if (!plug.principalId) {
    throw new Error('Failed to get principal ID from Plug extension')
  }

  plug.onExternalDisconnect(() => {
    useConnectionProvider.setState({ provider: null })
  })

  return { principal: plug.principalId }
}
